import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Biography = () => {
  const { t } = useTranslation();
  const bio = t("biography", { returnObjects: true });

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        color: "#000",
        py: { xs: 4, md: 8 },
        px: { xs: 2, md: 6 },
        minHeight: "100vh",
      }}
    >
      <Container maxWidth="lg">
        {/* Title */}
        <Typography
          variant="h3"
          align="center"
          sx={{
            fontWeight: 700,
            color: "#000",
            mb: 6,
            textShadow: "0 0 8px rgba(255, 215, 0, 0.4)",
          }}
        >
          {bio.title}
        </Typography>

        <motion.div
          initial={{ width: 0 }}
          animate={{ width: "120px" }}
          transition={{ duration: 1 }}
          style={{
            height: "4px",
            margin: "0 auto 40px",
            background:
              "linear-gradient(90deg, rgba(255,215,0,1) 0%, rgba(255,239,170,1) 100%)",
            borderRadius: "2px",
          }}
        />

        {/* Image + Details container */}
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            flexWrap: { xs: "wrap", md: "nowrap" },
            gap: 4,
          }}
        >
          {/* Left: Image */}
          <motion.img
            src={bio.image}
            alt="Gurudev"
            style={{
              width: "100%",
              maxWidth: "380px",
              borderRadius: "16px",
              border: "3px solid #FFD700",
              boxShadow: "0 0 20px rgba(255, 215, 0, 0.4)",
              height: "290px",
              // objectFit: "cover",
            }}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
          />

          {/* Right: Text Details */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4 }}
            style={{
              backgroundColor: "#000",
              color: "#FFD700",
              padding: "30px",
              borderRadius: "16px",
              boxShadow: "0 0 20px rgba(255, 215, 0, 0.4)",
              flex: 1,
              minWidth: "300px",
            }}
          >
            {/* अपनी मातृभूमि भारतमाता यह एक रत्नोंसे भरा हुआ भण्डार है | इसका आँचल उज्वल, जगमगाते, जीवन्त रत्नोंसे भरा हुआ है | ऐसे पुण्य भूमि पर सैकड़ो ऐसे महयोगियों, महापुरुषों एवं संत महात्माओंका आर्विभाव हुआ है, जिन्होंने लाखो व्यक्तियोंको आडम्बर और क्रिया कर्मोंसे बचाकर आत्मकल्याण का सही मार्ग दिखाकर, उसका जीवन धन्य किया है | अब कलियुग में धर्म ही लुप्त हो रहा है | ऐसे समय उनके साहित्य और ज्ञान के भण्डार को उन्होंने समृद्र किया है | ऐसी ही बिकट परिस्थितीमे राजस्थानकी मरुभमि में मांडोली नगरीमें एक "पूर्ण योगी"   */}
            {bio.details.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  py: 1.2,
                  borderBottom: "1px solid rgba(255,215,0,0.2)",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "1.1rem",
                    color: "#FFD700",
                    minWidth: "45%",
                  }}
                >
                  {item.label}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "1.1rem",
                    color: "#fff",
                    textAlign: "right",
                    flex: 1,
                  }}
                >
                  {item.value}
                </Typography>
              </Box>
            ))}
          </motion.div>
        </Box>
        {/* 🪔 Biography Paragraphs (below image + info) */}
        <Box sx={{ mt: 6 }}>
          {bio.content &&
            bio.content.map((paragraph, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                // transition={{ duration: 0.15, delay: index * 0.05 }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "1.1rem",
                    color: "#333",
                    mb: 3,
                    lineHeight: 1.4,  // 👈 adjust line height
                    marginBottom: "14px",  // 👈 custom margin bottom
                    textAlign: "justify",
                  }}
                >
                  {paragraph}
                </Typography>
              </motion.div>
            ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Biography;
